<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Contact'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="tit">Contact CorDx</div>
			</div>
			<!--块1-->
			<!--banner-->
			<div class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<img src="../../assets/img/组-643@2x.webp" />
			</div>
			<!--banner-->
			<!--块2-->
			<div class="block_2"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="left">
					<div class="title">Contact us</div>
					<div class="left_el">
						<div class="img_box">
							<img src="../../assets/img/icon@2x.png" />
						</div>
						<div class="tit_box">5900 Windward Pkwy, Alpharetta, GA 30005</div>
					</div>
					<!-- <div class="left_el">
						<div class="img_box">
							<img src="../../assets/img/icon@2x.png" />
						</div>
						<div class="tit_box">9540 Waples St. #C, San Diego, CA 92121</div>
					</div> -->
					<div class="left_el">
						<div class="img_box">
							<img src="../../assets/img/icon@2x (1).png" />
						</div>
						<div class="tit_box">+1 (800) 711-5355</div>
					</div>
					<div class="left_el">
						<div class="img_box">
							<img src="../../assets/img/icon@2x (2).png" />
						</div>
						<div class="tit_box"><a style="color: #000000 !important;" href="mailto:info@cordx.com">info@cordx.com</a></div>
					</div>
				</div>
				<div class="right">
					<contact></contact>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import fixed from '@/component/pc/fixed.vue'  //联系我们悬浮
import contact from '@/component/pc/contact.vue'  //联系我们
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
			isShow: null,
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Contact - CorDx';
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	/*块2*/
	.block_2{
		width: 1140px;
		display: flex;
		margin: 0 auto;
		padding: 140px 0;
		.left{
			width: 400px;
			padding-right: 100px;
			.left_el{
				display: flex;
				align-items: center;
				padding-bottom: 30px;
				.tit_box{
					flex: 1;
					padding-left: 10px;
					a{
						color: #000000;
					}
				}
				.img_box{
					width: 30px;
					img{ width: 100%; }
				}
			}
			.title{
				padding-bottom: 30px;
				font-size: 45px;
				color: #000000;
			}
		}
		.right{
			flex: 1;
		}
	}
	/*banner*/
	.banner_box{
		img{
			width: 100%;
		}
	}
	/*块1*/
	.block_1{
		width: 1140px;
		margin: 0 auto;
		padding: 50px 50px 0 50px;
		color: #000000;
		text-align: center;
		.tit{
			font-size: 65px;
		}
		.txt{
			font-size: 30px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 0 28px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
	.btn_box_more:hover{
		img{
			transform: translateX(6px);
		}
		background-color: #f5f8fa;
	}
}
</style>
